import { render, staticRenderFns } from "./PsIndicatorAmount.vue?vue&type=template&id=65263f88&scoped=true&"
import script from "./PsIndicatorAmount.vue?vue&type=script&lang=js&"
export * from "./PsIndicatorAmount.vue?vue&type=script&lang=js&"
import style0 from "./PsIndicatorAmount.vue?vue&type=style&index=0&id=65263f88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65263f88",
  null
  
)

export default component.exports